
import { fetchCountries, type Country } from "@/app/services/localservices/countryService";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

interface CountryState {
  data: Country[];
  loading: boolean;
  error: string | null;
}

const initialState: CountryState = {
  data: [],
  loading: false,
  error: null,
};

// Async thunk (fetch once)
export const loadCountries = createAsyncThunk(
  "countries/load",
  async () => {
    return await fetchCountries();
  }
);

const countrySlice = createSlice({
  name: "countries",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadCountries.pending, (state) => {
        state.loading = true;
      })
      .addCase(loadCountries.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(loadCountries.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to load countries";
      });
  },
});

export default countrySlice.reducer;
